import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IClinicParavetMapUpdateBody } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useClinicParavetMappingAddAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (clinicId: string, body: IClinicParavetMapUpdateBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const url = `${CONFIGURATION_APIS.CLINIC_PARAVET_MAP_UPDATE.baseURL}${clinicId}/`;
        const response = await axios.post(url, body, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        const rejected = response.data?.data?.rejected || [];
        if (rejected.length > 0) {
          toast.error(
            `Could not map ${rejected.length} paravet(s): ${rejected
              .map((r: any) => r.reason)
              .join(", ")
              .toLowerCase()}`,
          );
        } else {
          toast.success("Paravets mapped to clinic");
        }
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }

        throw error;
      }
    },
    [captureError, configuration, sendCurl],
  );

  return { execute };
};
